/*
// import {createTheme} from '@mui/material/styles';
//
// const theme = createTheme({
//     palette: {
//         primary: {
//             main: '#E08A90',
//             light: '#F0C8C8',
//             dark: '#D97A81',
//             contrastText: '#FFFFFF',
//         },
//
//         secondary: {
//             main: '#2D2A26',
//             light: '#6E625D',
//         },
//
//         background: {
//             default: '#F9F0ED',
//             paper: '#FFFFFF',
//         },
//
//         text: {
//             primary: '#2D2A26',
//             secondary: '#6E625D',
//             disabled: '#A89C96',
//         },
//
//         success: {
//             main: '#7BC67B',
//             light: '#EAF8EA',
//         },
//
//         warning: {
//             main: '#F4B26B',
//             light: '#FFF3E6',
//         },
//
//         info: {
//             main: '#7AA8E8',
//             light: '#EEF5FF',
//         },
//
//         error: {
//             main: '#E57373',
//             light: '#FDEDED',
//         },
//
//         divider: '#E8E0E0',
//     },
//
//     shape: {
//         borderRadius: 12,
//     },
//
//     typography: {
//         fontFamily: '"Inter", "Roboto", "Arial", sans-serif',
//
//         h1: {color: '#2D2A26'},
//         h2: {color: '#2D2A26'},
//         h3: {color: '#2D2A26'},
//
//         body1: {
//             color: '#2D2A26',
//         },
//
//         body2: {
//             color: '#6E625D',
//         },
//     },
//
//     components: {
//         MuiButton: {
//             styleOverrides: {
//                 root: {
//                     textTransform: 'none',
//                     borderRadius: 12,
//                 },
//                 containedPrimary: {
//                     backgroundColor: '#E08A90',
//                     '&:hover': {
//                         backgroundColor: '#D97A81',
//                     },
//                 },
//                 containedSecondary: {
//                     backgroundColor: '#FFFFFF',
//                     color: '#2D2A26',
//                 },
//                 disabled: {
//                     backgroundColor: '#E5DCDC',
//                     color: '#B8AEAA',
//                 },
//             },
//         },
//
//         MuiPaper: {
//             styleOverrides: {
//                 root: {
//                     backgroundColor: '#FFFFFF',
//                     borderRadius: 12,
//                 },
//             },
//         },
//
//         MuiAppBar: {
//             styleOverrides: {
//                 root: {
//                     backgroundColor: '#FFFFFF',
//                     color: '#2D2A26',
//                 },
//             },
//         },
//     },
// });
//
// export default theme;

// theme.js
*/
/*
import {alpha, createTheme} from '@mui/material/styles';

const theme = createTheme({
    shape: {
        borderRadius: 14,
    },

    palette: {
        mode: 'light',

        primary: {
            main: '#E08A90',
            light: '#F0C8C8',
            dark: '#D97A81',
            contrastText: '#FFFFFF',
        },

        secondary: {
            main: '#2D2A26',
            light: '#6E625D',
        },

        background: {
            default: '#F9F0ED',
            paper: '#FFFFFF',
        },

        text: {
            primary: '#2D2A26',
            secondary: '#6E625D',
            disabled: '#A89C96',
        },

        divider: '#EFE8E6',

        success: {
            main: '#7BC67B',
            light: '#EAF8EA',
        },

        warning: {
            main: '#F4B26B',
            light: '#FFF3E6',
        },

        info: {
            main: '#7AA8E8',
            light: '#EEF5FF',
        },

        error: {
            main: '#E57373',
            light: '#FDEDED',
        },

        grey: {
            100: '#F8F8F8',
            200: '#F6F0EB',
            300: '#EFE8E6',
            400: '#E8E0E0',
            500: '#D8D8D8',
            600: '#C7BDB8',
            700: '#B8AEAA',
        },
    },

    typography: {
        fontFamily: 'Inter, Roboto, Arial, sans-serif',

        h1: {
            fontFamily: 'Playfair Display, serif',
            fontSize: '2rem',
            fontWeight: 700,
            lineHeight: 1.2,
            letterSpacing: '-0.01em',
            color: '#2D2A26',
        },

        h2: {
            fontFamily: 'Playfair Display, serif',
            fontSize: '1.75rem',
            fontWeight: 600,
            lineHeight: 1.25,
            color: '#2D2A26',
        },

        h3: {
            fontFamily: 'Playfair Display, serif',
            fontSize: '1.5rem',
            fontWeight: 600,
            lineHeight: 1.3,
            color: '#2D2A26',
        },

        h4: {
            fontSize: '1.25rem',
            fontWeight: 600,
            color: '#2D2A26',
        },

        body1: {
            fontSize: '1rem',
            lineHeight: 1.6,
            color: '#2D2A26',
        },

        body2: {
            fontSize: '0.875rem',
            lineHeight: 1.5,
            color: '#6E625D',
        },

        caption: {
            fontSize: '0.75rem',
            fontWeight: 500,
            color: '#A89C96',
        },

        button: {
            fontWeight: 600,
            textTransform: 'none',
            letterSpacing: '0',
        },
    },

    // shadows: [
    //     'none',
    //     '0 4px 16px rgba(45, 42, 38, 0.06)',
    //     '0 10px 30px rgba(224, 138, 144, 0.18)',
    //     ...Array(22).fill('0 4px 16px rgba(45, 42, 38, 0.06)'),
    // ],

    components: {
        MuiCssBaseline: {
            styleOverrides: {
                body: {
                    backgroundColor: '#F9F0ED',
                    color: '#2D2A26',
                    WebkitFontSmoothing: 'antialiased',
                    MozOsxFontSmoothing: 'grayscale',
                },
            },
        },

        MuiButton: {
            defaultProps: {
                disableElevation: true,
            },

            styleOverrides: {
                root: {
                    minHeight: 52,
                    borderRadius: 14,
                    paddingLeft: 20,
                    paddingRight: 20,
                    fontWeight: 600,
                    boxShadow: '0 4px 16px rgba(45, 42, 38, 0.06)',
                    transition: 'all 150ms ease',
                },

                containedPrimary: {
                    backgroundColor: '#E08A90',
                    color: '#FFFFFF',

                    '&:hover': {
                        backgroundColor: '#D97A81',
                    },

                    '&:active': {
                        backgroundColor: '#C96B72',
                    },

                    '&.Mui-disabled': {
                        backgroundColor: '#E5DCDC',
                        color: '#B8AEAA',
                    },
                },

                outlined: {
                    backgroundColor: '#FFFFFF',
                    border: '1px solid #E8E0E0',
                    color: '#2D2A26',

                    '&:hover': {
                        backgroundColor: '#FFF8F2',
                        borderColor: '#E08A90',
                    },
                },

                text: {
                    color: '#E08A90',

                    '&:hover': {
                        backgroundColor: 'rgba(224,138,144,0.08)',
                    },
                },
            },
        },

        MuiPaper: {
            styleOverrides: {
                root: {
                    backgroundColor: '#FFFFFF',
                    borderRadius: 20,
                    boxShadow: '0 4px 16px rgba(45, 42, 38, 0.06)',
                    backgroundImage: 'none',
                },
            },
        },

        MuiCard: {
            styleOverrides: {
                root: {
                    borderRadius: 20,
                    padding: 20,
                    boxShadow: '0 4px 16px rgba(45, 42, 38, 0.06)',
                },
            },
        },

        MuiOutlinedInput: {
            styleOverrides: {
                root: {
                    minHeight: 52,
                    borderRadius: 14,
                    backgroundColor: '#FFFFFF',

                    '& .MuiOutlinedInput-notchedOutline': {
                        borderColor: '#E8E0E0',
                    },

                    '&:hover .MuiOutlinedInput-notchedOutline': {
                        borderColor: '#E08A90',
                    },

                    '&.Mui-focused .MuiOutlinedInput-notchedOutline': {
                        borderColor: '#E08A90',
                        borderWidth: 1,
                    },

                    '&.Mui-focused': {
                        boxShadow: '0 0 0 4px rgba(224,138,144,0.12)',
                    },

                    '&.Mui-disabled': {
                        backgroundColor: '#F6F0EB',
                    },
                },

                input: {
                    padding: 16,
                },
            },
        },

        MuiTableHead: {
            styleOverrides: {
                root: {
                    backgroundColor: '#F8F8F8',
                },
            },
        },
// TODO: uncomment after when we use not accordion in table
        // MuiTableCell: {
        //     styleOverrides: {
        //         head: {
        //             height: 56,
        //             borderBottom: '1px solid #EFE8E6',
        //             color: '#6E625D',
        //             fontWeight: 600,
        //         },
        //
        //         body: {
        //             height: 72,
        //             borderBottom: '1px solid #EFE8E6',
        //         },
        //     },
        // },

        MuiTableRow: {
            styleOverrides: {
                root: {
                    '&:hover': {
                        backgroundColor: '#FFF8F2',
                    },
                },
            },
        },

        MuiChip: {
            styleOverrides: {
                root: {
                    borderRadius: 999,
                    fontWeight: 600,
                },
            },
        },

        MuiDialog: {
            styleOverrides: {
                paper: {
                    borderRadius: 28,
                    padding: 24,
                },
            },
        },

        MuiAppBar: {
            styleOverrides: {
                root: {
                    backgroundColor: '#FFFFFF',
                    color: '#2D2A26',
                    boxShadow: '0 4px 16px rgba(45, 42, 38, 0.06)',
                    backgroundImage: 'none',
                },
            },
        },

        MuiFab: {
            styleOverrides: {
                root: {
                    width: 64,
                    height: 64,
                    borderRadius: 999,
                    backgroundColor: '#E08A90',
                    color: '#FFFFFF',
                    boxShadow: '0 10px 30px rgba(224, 138, 144, 0.18)',

                    '&:hover': {
                        backgroundColor: '#D97A81',
                    },
                },
            },
        },
    },
});

export default theme;*/
import { alpha, createTheme } from '@mui/material/styles';
const theme = createTheme({
    shape: {
        borderRadius: 12,
    },
    spacing: 8,
    //«Шоколад и Капучино»
    //#region
    palette: {
        mode: 'light',
        primary: {
            main: '#9A5A3C',
            light: '#D9A88F',
            dark: '#6B3E2E',
            contrastText: '#FFFFFF',
        },
        secondary: {
            main: '#8DAA91',
            light: '#DDE5DE',
        },
        background: {
            default: '#FAFAF8',
            paper: '#FFFFFF',
        },
        text: {
            primary: '#1C1C1C',
            secondary: '#4B4B4B',
            disabled: '#7A7A7A',
        },
        divider: '#E9E9E9',
        success: {
            main: '#2E7D5B',
            light: '#DDF3EA',
        },
        warning: {
            main: '#F4A340',
            light: '#FFF3E3',
        },
        error: {
            main: '#E45757',
            light: '#FDEAEA',
        },
        info: {
            main: '#7AA8E8',
            light: '#EEF5FF',
        },
        grey: {
            100: '#F7F7F7',
            200: '#E9E9E9',
            300: '#D6D6D6',
            400: '#BDBDBD',
            500: '#7A7A7A',
            700: '#4B4B4B',
            900: '#1C1C1C',
        },
    },
    //#endregion
    // «Черничный мусс и Сливки»
    //#region
    // palette: {
    //     mode: 'light',
    //     primary: {
    //         main: '#5C3A69',       // Глубокий черничный / смородиновый
    //         light: '#A381AF',      // Нежный лавандовый мусс
    //         dark: '#382242',       // Темный виноград
    //         contrastText: '#FFFFFF',
    //     },
    //     secondary: {
    //         main: '#E5A9B4',       // Клубничный макарон (для акцентов, тегов)
    //         light: '#F5D6DA',
    //     },
    //     background: {
    //         default: '#FAFAFC',    // Холодный белый с каплей молока
    //         paper: '#FFFFFF',
    //     },
    //     text: {
    //         primary: '#231E26',    // Почти черный с баклажановым отливом
    //         secondary: '#5A525F',
    //         disabled: '#A097A4',
    //     },
    //     divider: '#EFECEF',
    // },
    //#endregion
    //«Мята и Фисташка» топчик топчик
    //#region
    // palette: {
    //     mode: 'light',
    //     primary: {
    //         main: '#2D725F',       // Глубокий мятный / матовый зеленый
    //         light: '#72B09F',      // Фисташковый крем
    //         dark: '#1A473B',       // Хвойный зеленый
    //         contrastText: '#FFFFFF',
    //     },
    //     secondary: {
    //         main: '#D4A373',       // Песочное тесто (для контрастных элементов)
    //         light: '#E3D5CA',
    //     },
    //     background: {
    //         default: '#F7F9F8',    // Свежий чистый фон
    //         paper: '#FFFFFF',
    //     },
    //     text: {
    //         primary: '#1A2421',    // Темно-зеленый графит
    //         secondary: '#4A5753',
    //         disabled: '#8C9B96',
    //     },
    //     divider: '#E6ECE9',
    // },
    //#endregion
    //«Карамель и Ваниль»
    //#region
    // palette: {
    //     mode: 'light',
    //     primary: {
    //         main: '#C67A4B',       // Тягучая карамель
    //         light: '#E9BA9B',      // Ванильный бисквит
    //         dark: '#874D27',       // Жженый сахар
    //         contrastText: '#FFFFFF',
    //     },
    //     secondary: {
    //         main: '#5C544E',       // Шоколадно-серый (для интерфейсного нейтралитета)
    //         light: '#968E87',
    //     },
    //     background: {
    //         default: '#FAF8F5',    // Топленое молоко
    //         paper: '#FFFFFF',
    //     },
    //     text: {
    //         primary: '#2B2520',    // Горький шоколад для текста
    //         secondary: '#615852',
    //         disabled: '#A39992',
    //     },
    //     divider: '#EFEAE4',
    // },
    //#endregion
    //«Матча-Латте и Белый Шоколад»
    //#region
    // palette: {
    //     mode: 'light',
    //     primary: {
    //         main: '#526E52',       // Сухая матча (мягкий, глубокий зеленый)
    //         light: '#9BB89B',      // Зеленый чай с молоком
    //         dark: '#344A34',       // Насыщенный травяной
    //         contrastText: '#FFFFFF',
    //     },
    //     secondary: {
    //         main: '#D0A97E',       // Овсяное печенье / тарталетка
    //         light: '#E6CBB0',
    //     },
    //     background: {
    //         default: '#F5F7F4',    // Молочная сыворотка
    //         paper: '#FFFFFF',
    //     },
    //     text: {
    //         primary: '#1D241D',    // Глубокий хвойно-черный
    //         secondary: '#505950',
    //     },
    //     divider: '#E5EAE4',
    // },
    //#endregion
    //«Лимонный Сорбет и Шалфей»
    //#region
    // palette: {
    //     mode: 'light',
    //     primary: {
    //         main: '#4A6B62',       // Благородный шалфейный зеленый
    //         light: '#8FAEA5',      // Разбеленная хвоя
    //         dark: '#2E4741',       // Теневой зеленый
    //         contrastText: '#FFFFFF',
    //     },
    //     secondary: {
    //         main: '#EBC064',       // Лимонный курд / сорбет
    //         light: '#F5DEAB',
    //     },
    //     background: {
    //         default: '#F6F8F6',    // Натуральный светлый фон
    //         paper: '#FFFFFF',
    //     },
    //     text: {
    //         primary: '#1F2624',    // Грифельно-зеленый
    //         secondary: '#54605C',
    //     },
    //     divider: '#E7ECE9',
    // },
    //#endregion
    //«Малиновый Шелк и Пломбир» топчик
    //#region
    // palette: {
    //     mode: 'light',
    //     primary: {
    //         main: '#A95E71',       // Припыленная малина (очень комфортная для глаз)
    //         light: '#DCA2AF',      // Клубничный зефир
    //         dark: '#733746',       // Спелая вишня
    //         contrastText: '#FFFFFF',
    //     },
    //     secondary: {
    //         main: '#526760',       // Холодный эвкалипт (для баланса ягодных тонов)
    //         light: '#8EA39D',
    //     },
    //     background: {
    //         default: '#FAFAF9',    // Ванильный пломбир
    //         paper: '#FFFFFF',
    //     },
    //     text: {
    //         primary: '#2B2023',    // Шоколадно-бордовый оттенок черного
    //         secondary: '#5E5053',
    //     },
    //     divider: '#F1ECEF',
    // },
    //#endregion
    typography: {
        fontFamily: 'Inter, SF Pro Display, system-ui, sans-serif',
        h1: {
            fontSize: '3.25rem',
            fontWeight: 700,
            lineHeight: 1.1,
            letterSpacing: '-0.03em',
            color: '#1C1C1C',
        },
        h2: {
            fontSize: '1.75rem',
            fontWeight: 600,
            lineHeight: 1.2,
            letterSpacing: '-0.02em',
            color: '#1C1C1C',
        },
        h3: {
            fontSize: '1.125rem',
            fontWeight: 600,
            lineHeight: 1.3,
            color: '#1C1C1C',
        },
        h4: {
            fontSize: '1rem',
            fontWeight: 600,
            lineHeight: 1.4,
            color: '#1C1C1C',
        },
        body1: {
            fontSize: '1rem',
            fontWeight: 400,
            lineHeight: 1.5,
            color: '#1C1C1C',
        },
        body2: {
            fontSize: '0.875rem',
            fontWeight: 400,
            lineHeight: 1.4,
            color: '#4B4B4B',
        },
        caption: {
            fontSize: '0.75rem',
            fontWeight: 500,
            lineHeight: 1.3,
            color: '#7A7A7A',
        },
        button: {
            fontSize: '0.95rem',
            fontWeight: 600,
            textTransform: 'none',
            letterSpacing: '0',
        },
    },
    /*    shadows: [
            'none',
            '0 2px 8px rgba(0,0,0,0.04)',
            '0 4px 12px rgba(0,0,0,0.05)',
            '0 8px 24px rgba(0,0,0,0.05)',
            ...Array(21).fill('0 8px 24px rgba(0,0,0,0.05)'),
        ],*/
    components: {
        MuiCssBaseline: {
            styleOverrides: {
                body: {
                    backgroundColor: '#FAFAF8',
                    color: '#1C1C1C',
                    WebkitFontSmoothing: 'antialiased',
                    MozOsxFontSmoothing: 'grayscale',
                },
                '*': {
                    boxSizing: 'border-box',
                },
            },
        },
        MuiButton: {
            defaultProps: {
                disableElevation: true,
            },
            styleOverrides: {
                root: {
                    minHeight: 48,
                    borderRadius: 12,
                    paddingLeft: 20,
                    paddingRight: 20,
                    fontWeight: 600,
                    boxShadow: 'none',
                    transition: 'all 150ms ease',
                    '&:focus-visible': {
                        outline: '3px solid rgba(154,90,60,0.22)',
                        outlineOffset: 2,
                    },
                },
                sizeSmall: {
                    minHeight: 36,
                    paddingLeft: 12,
                    paddingRight: 12,
                },
                sizeLarge: {
                    minHeight: 56,
                    paddingLeft: 24,
                    paddingRight: 24,
                },
                containedPrimary: {
                    background: 'linear-gradient(180deg, rgba(255,255,255,0.10) 0%, rgba(255,255,255,0) 45%), linear-gradient(90deg, #8F5338 0%, #A66342 50%, #C27A52 100%)',
                    color: '#FFFFFF',
                    boxShadow: '0 4px 12px rgba(154,90,60,0.18)',
                    '&:hover': {
                        background: 'linear-gradient(90deg, #6B3E2E 0%, #8A5238 50%, #A66342 100%)',
                        boxShadow: '0 6px 18px rgba(154,90,60,0.24)',
                    },
                    '&:active': {
                        background: 'linear-gradient(90deg, #5A3123 0%, #74412E 100%)',
                    },
                    '&.Mui-disabled': {
                        background: '#E9E9E9',
                        color: '#7A7A7A',
                        boxShadow: 'none',
                    },
                },
                outlined: {
                    backgroundColor: '#FFFFFF',
                    border: '1px solid #D9A88F',
                    color: '#6B3E2E',
                    boxShadow: '0 1px 3px rgba(0,0,0,0.12)',
                    '&:hover': {
                        backgroundColor: '#D9A88F',
                        borderColor: '#9A5A3C',
                    },
                    '&.MuiButton-colorError': {
                        borderColor: '#E45757',
                        color: '#E45757',
                        '&:hover': {
                            backgroundColor: '#FDEAEA',
                        },
                    },
                    '&.MuiButton-colorSuccess': {
                        borderColor: '#2E7D5B',
                        color: '#2E7D5B',
                        '&:hover': {
                            backgroundColor: '#DDF3EA',
                            borderColor: '#2E7D5B',
                        },
                    },
                },
                text: {
                    color: '#9A5A3C',
                    '&:hover': {
                        backgroundColor: 'rgba(154,90,60,0.08)',
                    },
                },
            },
        },
        MuiIconButton: {
            styleOverrides: {
                root: {
                    color: '#6B3E2E',
                    minWidth: 44,
                    minHeight: 44,
                    transition: 'background-color 150ms ease, color 150ms ease',
                    '&:hover': {
                        backgroundColor: 'rgba(154,90,60,0.08)',
                    },
                },
            },
        },
        MuiPaper: {
            styleOverrides: {
                root: {
                    backgroundColor: '#FFFFFF',
                    borderRadius: 16,
                    border: '1px solid #E9E9E9',
                    boxShadow: '0 4px 16px rgba(28,28,28,0.035)',
                    backgroundImage: 'none',
                },
            },
        },
        MuiCard: {
            styleOverrides: {
                root: {
                    borderRadius: 16,
                    border: '1px solid #E9E9E9',
                    // padding: 24,
                    boxShadow: '0 4px 16px rgba(28,28,28,0.035)',
                },
            },
        },
        MuiOutlinedInput: {
            styleOverrides: {
                root: {
                    minHeight: 48,
                    borderRadius: 12,
                    backgroundColor: '#FFFFFF',
                    '& .MuiOutlinedInput-notchedOutline': {
                        borderColor: '#D6D6D6',
                    },
                    '&:hover .MuiOutlinedInput-notchedOutline': {
                        borderColor: '#9A5A3C',
                    },
                    '&.Mui-focused .MuiOutlinedInput-notchedOutline': {
                        borderColor: '#D9A88F',
                        borderWidth: 2,
                    },
                    '&.Mui-disabled': { backgroundColor: '#F7F7F7' },
                },
                input: {
                //padding: '12px 14px',
                },
            },
        },
        MuiInputLabel: {
            styleOverrides: {
                root: {
                    color: '#4B4B4B',
                    '&.Mui-focused': {
                        color: '#9A5A3C',
                    },
                },
            },
        },
        MuiTableHead: {
            styleOverrides: {
                root: {
                    backgroundColor: '#F7F7F7',
                },
            },
        },
        // TODO: uncomment after when we use not accordion in table
        /*MuiTableCell: {
            styleOverrides: {
                head: {
                    height: 56,
                    borderBottom: '1px solid #E9E9E9',
                    color: '#4B4B4B',
                    fontWeight: 600,
                    fontSize: '0.875rem',
                },

                body: {
                    height: 64,
                    borderBottom: '1px solid #E9E9E9',
                },
            },
        },*/
        MuiTableRow: {
            styleOverrides: {
                root: {
                    transition: 'background-color 120ms ease',
                    '&:hover': {
                        backgroundColor: '#F5E7DF',
                    },
                },
            },
        },
        MuiChip: {
            styleOverrides: {
                root: {
                    borderRadius: 999,
                    fontWeight: 600,
                    height: 28,
                },
            },
        },
        MuiTabs: {
            styleOverrides: {
                root: { minHeight: 48, borderBottom: '1px solid #E9E9E9' },
                indicator: { height: 3, borderRadius: '3px 3px 0 0' },
                scrollButtons: { '&.Mui-disabled': { opacity: 0.25 } },
            },
        },
        MuiTab: {
            styleOverrides: {
                root: {
                    minHeight: 48,
                    minWidth: 0,
                    padding: '10px 16px',
                    fontSize: '0.9rem',
                    fontWeight: 600,
                    textTransform: 'none',
                },
            },
        },
        MuiAlert: {
            styleOverrides: {
                root: { borderRadius: 12, border: '1px solid transparent' },
                standardInfo: { borderColor: '#DCE9FA' },
                standardSuccess: { borderColor: '#CBE7DC' },
                standardWarning: { borderColor: '#F4DFC0' },
                standardError: { borderColor: '#F5D3D3' },
            },
        },
        MuiDialog: {
            styleOverrides: {
                paper: {
                    borderRadius: 20,
                    padding: 24,
                    border: '1px solid #E9E9E9',
                },
            },
        },
        MuiAppBar: {
            styleOverrides: {
                root: {
                    backgroundColor: '#FFFFFF',
                    color: '#1C1C1C',
                    borderBottom: '1px solid #E9E9E9',
                    boxShadow: 'none',
                    backgroundImage: 'none',
                },
            },
        },
        MuiDrawer: {
            styleOverrides: {
                paper: {
                    backgroundColor: '#FFFFFF',
                    borderRight: '1px solid #E9E9E9',
                },
            },
        },
        MuiFab: {
            styleOverrides: {
                root: {
                    width: 56,
                    height: 56,
                    borderRadius: 999,
                    backgroundColor: '#9A5A3C',
                    color: '#FFFFFF',
                    boxShadow: '0 10px 24px rgba(154,90,60,0.22)',
                    '&:hover': {
                        backgroundColor: '#6B3E2E',
                    },
                },
            },
        },
        MuiDivider: {
            styleOverrides: {
                root: {
                    borderColor: '#E9E9E9',
                },
            },
        },
        MuiTooltip: {
            styleOverrides: {
                tooltip: {
                    borderRadius: 10,
                    backgroundColor: '#1C1C1C',
                    fontSize: '0.75rem',
                },
            },
        },
    },
});
export default theme;
export const DEFAULT_APP_THEME = 'chocolate';
export const appThemeOptions = [
    { id: 'chocolate', labelKey: 'common:theme_chocolate', color: '#9A5A3C' },
    { id: 'blueberry', labelKey: 'common:theme_blueberry', color: '#5C3A69' },
    { id: 'pistachio', labelKey: 'common:theme_pistachio', color: '#2D725F' },
    { id: 'caramel', labelKey: 'common:theme_caramel', color: '#C67A4B' },
    { id: 'raspberry', labelKey: 'common:theme_raspberry', color: '#A95E71' },
];
const appPalettes = {
    chocolate: {
        primary: { main: '#9A5A3C', light: '#D9A88F', dark: '#6B3E2E' },
        secondary: { main: '#8DAA91', light: '#DDE5DE' },
        background: { default: '#FAFAF8', paper: '#FFFFFF' },
        text: { primary: '#1C1C1C', secondary: '#4B4B4B', disabled: '#7A7A7A' },
        divider: '#E9E9E9',
    },
    blueberry: {
        primary: { main: '#5C3A69', light: '#A381AF', dark: '#382242' },
        secondary: { main: '#C78393', light: '#F5D6DA' },
        background: { default: '#F8F7FA', paper: '#FFFFFF' },
        text: { primary: '#231E26', secondary: '#5A525F', disabled: '#8F8793' },
        divider: '#E9E4EC',
    },
    pistachio: {
        primary: { main: '#2D725F', light: '#72B09F', dark: '#1A473B' },
        secondary: { main: '#B98255', light: '#E3D5CA' },
        background: { default: '#F5F8F6', paper: '#FFFFFF' },
        text: { primary: '#1A2421', secondary: '#4A5753', disabled: '#7D8C87' },
        divider: '#DEE7E2',
    },
    caramel: {
        primary: { main: '#B8683B', light: '#E9BA9B', dark: '#7A4223' },
        secondary: { main: '#5C544E', light: '#D6D0CB' },
        background: { default: '#FAF7F2', paper: '#FFFFFF' },
        text: { primary: '#2B2520', secondary: '#615852', disabled: '#958A82' },
        divider: '#EAE2D8',
    },
    raspberry: {
        primary: { main: '#A34F65', light: '#DCA2AF', dark: '#6E3040' },
        secondary: { main: '#526760', light: '#B8C7C2' },
        background: { default: '#FAF7F8', paper: '#FFFFFF' },
        text: { primary: '#2B2023', secondary: '#5E5053', disabled: '#94878A' },
        divider: '#EDE4E7',
    },
};
export const isAppThemeId = (value) => appThemeOptions.some(option => option.id === value);
export const createAppTheme = (themeId) => {
    const colors = appPalettes[themeId];
    return createTheme(theme, {
        palette: {
            primary: Object.assign(Object.assign({}, colors.primary), { contrastText: '#FFFFFF' }),
            secondary: colors.secondary,
            background: colors.background,
            text: colors.text,
            divider: colors.divider,
        },
        components: {
            MuiCssBaseline: { styleOverrides: { body: { backgroundColor: colors.background.default, color: colors.text.primary } } },
            MuiButton: { styleOverrides: {
                    root: { '&:focus-visible': { outline: `3px solid ${alpha(colors.primary.main, 0.22)}` } },
                    containedPrimary: { background: colors.primary.main, color: '#FFFFFF', boxShadow: `0 4px 12px ${alpha(colors.primary.main, 0.2)}`, '&:hover': { background: colors.primary.dark, boxShadow: `0 6px 18px ${alpha(colors.primary.main, 0.26)}` }, '&:active': { background: colors.primary.dark } },
                    outlined: { backgroundColor: colors.background.paper, borderColor: colors.primary.light, color: colors.primary.dark, '&:hover': { backgroundColor: alpha(colors.primary.main, 0.09), borderColor: colors.primary.main } },
                    text: { color: colors.primary.main, '&:hover': { backgroundColor: alpha(colors.primary.main, 0.08) } },
                } },
            MuiIconButton: { styleOverrides: { root: { color: colors.primary.dark, '&:hover': { backgroundColor: alpha(colors.primary.main, 0.08) } } } },
            MuiPaper: { styleOverrides: { root: { backgroundColor: colors.background.paper, borderColor: colors.divider } } },
            MuiCard: { styleOverrides: { root: { borderColor: colors.divider } } },
            MuiOutlinedInput: { styleOverrides: { root: { backgroundColor: colors.background.paper, '& .MuiOutlinedInput-notchedOutline': { borderColor: colors.divider }, '&:hover .MuiOutlinedInput-notchedOutline': { borderColor: colors.primary.main }, '&.Mui-focused .MuiOutlinedInput-notchedOutline': { borderColor: colors.primary.light } } } },
            MuiInputLabel: { styleOverrides: { root: { color: colors.text.secondary, '&.Mui-focused': { color: colors.primary.main } } } },
            MuiTableHead: { styleOverrides: { root: { backgroundColor: alpha(colors.primary.main, 0.045) } } },
            MuiTableRow: { styleOverrides: { root: { '&:hover': { backgroundColor: alpha(colors.primary.main, 0.075) } } } },
            MuiTabs: { styleOverrides: { root: { borderBottomColor: colors.divider } } },
            MuiAppBar: { styleOverrides: { root: { backgroundColor: colors.background.paper, color: colors.text.primary, borderBottomColor: colors.divider } } },
            MuiDrawer: { styleOverrides: { paper: { backgroundColor: colors.background.paper, borderRightColor: colors.divider } } },
            MuiFab: { styleOverrides: { root: { backgroundColor: colors.primary.main, boxShadow: `0 10px 24px ${alpha(colors.primary.main, 0.24)}`, '&:hover': { backgroundColor: colors.primary.dark } } } },
            MuiDivider: { styleOverrides: { root: { borderColor: colors.divider } } },
            MuiTooltip: { styleOverrides: { tooltip: { backgroundColor: colors.text.primary } } },
        },
    });
};
